import React, { useState } from "react";
import "./about.css";
import { Waypoint } from "react-waypoint";
import imgAboutOne from "../../imgs/img-about-one.png";
import imgAboutTwo from "../../imgs/img-about-two.png";
import imgAboutThree from "../../imgs/img-about-three.png";
import imgAboutFour from "../../imgs/img-about-four.png";

export const About = () => {
  const [visible, setVisible] = useState(false);
  const [animatedCards, setAnimatedCards] = useState(0);

  const handleWaypointEnter = () => {
    setVisible(true);
  };

  return (
    <div
      className="w-full h-auto bg-white py-20 px-0 flex flex-col items-center"
      id="nosotros"
    >
      <Waypoint onEnter={handleWaypointEnter}>
        <div
          className={visible ? "section-header-animation" : "section-header"}
        >
          <h1 className="title-about text-bold relative mb-2 text-2xl md:text-3xl lg:text-4xl">
            Nosotros
          </h1>
          <p className="text-xl w-full text-center sm:w-96 md:text-2xl">
            Conoce más de nosotros y nuestros oyentes
          </p>
        </div>
      </Waypoint>
      <div className=" w-4/5">
        <div className=" w-full h-auto grid grid-cols-1 grid-rows-1 gap-4 md:grid-cols-2  ">
          <img src={imgAboutOne} alt="" className="max-w-full h-auto" />
          <img src={imgAboutTwo} alt="" className="max-w-full h-auto" />
          <img src={imgAboutThree} alt="" className="max-w-full h-auto" />
          <img src={imgAboutFour} alt="" className="max-w-full h-auto" />
        </div>
      </div>
    </div>
  );
};

// const [visible, setVisible] = useState(false);
// const [animatedCards, setAnimatedCards] = useState(0);

// const handleWaypointEnter = () => {
//   setVisible(true);
// };

// const handleWaypointEnterCards = () => {
//   setAnimatedCards((prevCount) => prevCount + 1);
// };

// const cards = [
//   {
//     img: mic,
//     title: "primer carta",
//     description:
//       "esta es la description repetida esta es la description repetida esta es la description repetida esta es la description repetida esta es la description repetida",
//   },
//   {
//     img: mic,
//     title: "segunda carta",
//     description:
//       "esta es la description repetida esta es la description repetida esta es la description repetida esta es la description repetida esta es la description repetida",
//   },
//   {
//     img: mic,
//     title: "tercer carta",
//     description:
//       "esta es la description repetida esta es la description repetida esta es la description repetida esta es la description repetidaesta es la description repetida",
//   },
//   {
//     img: mic,
//     title: "cuarta carta",
//     description:
//       "esta es la description repetida esta es la description repetidaesta es la description repetidaesta es la description repetidaesta es la description repetida",
//   },
// ].map((card, index) => {
//   return (
//     <Waypoint onEnter={handleWaypointEnterCards} key={index}>
//       <div
//         className={
//           index < animatedCards
//             ? `card-about-animated ${"card-" + index}`
//             : "card-about"
//         }
//       >
//         <img src={card.img} alt="" className="img-about-card" />
//         <div className="title-description">
//           <h2 className="title-about-card">{card.title}</h2>
//           <p className="description-about-card">{card.description}</p>
//         </div>
//       </div>
//     </Waypoint>
//   );
// });

{
  /* <Waypoint onEnter={handleWaypointEnter}>
<div
  className={
    visible ? "section-header-about-animation" : "section-header-about"
  }
>
  <h1 className="title-about">Nosotros</h1>
  <p className="subtitle-about">
    Voluptatem quibusdam ut ullam perferendis repellat non ut
    consequuntur est eveniet deleniti fignissimos eos quam
  </p>
</div>
</Waypoint>

<div className="cards-container-about">{cards.splice(0, 2)}</div>
<div className="cards-container-about">{cards.splice(0, 2)}</div> */
}
